// 1. Import your images at the top
import img01 from '../../../../assets/Service/01.png';
import img02 from '../../../../assets/Service/02.png';
import img03 from'../../../../assets/Service/03.png';
import img04 from '../../../../assets/Service/04.png';
import img05 from '../../../../assets/Service/05.png';
import img06 from '../../../../assets/Service/06.png';


import img1 from '../../../../assets/Service/1.jpg';
import img2 from '../../../../assets/Service/2.jpg';
import img3 from'../../../../assets/Service/3.jpg';
import img4 from '../../../../assets/Service/4.jpg';
import img5 from '../../../../assets/Service/5.jpg';
import img6 from '../../../../assets/Service/6.jpg';
/**
 * NUTRIVIO MEDICAL SERVICES PRIVATE LIMITED
 * Master Service Catalog Data File
 */

// -------------------------------------------------------------
// 01. NEW MEDICAL COLLEGE ESTABLISHMENT (FLAGSHIP)
// -------------------------------------------------------------
export const newMedicalCollegeData = {
  id: "new-medical-college-establishment",
  slug: "/services/new-medical-college-establishment",
  hero: {
    serviceName: "New Medical College Establishment",
    heading: "From Vision to Institution: Structured Advisory for New Medical Colleges",
    description:
      "Nutrivio Medical Services provides structured professional advisory and institutional support to organisations, trusts, and universities planning to establish a New Medical College & Teaching Hospital — from feasibility and infrastructure roadmap through to complete institutional readiness.",
    points: [
      "Preliminary Feasibility & Campus Roadmap Planning",
      "Teaching Hospital Bed & Clinical Material Assessment",
      "Department-wise Infrastructure & Laboratory Planning",
      "Permanent & Full-Time Medical Faculty Sourcing"
    ],
    buttonText: "Discuss Your Project",
    buttonLink: "#enquiry-form-section",
    illustrationUrl:img01 // Path to 01.png
  },
  about: {
    tagline: "Flagship Institutional Advisory",
    heading: "Building the Foundations of Medical Education Institutions",
    paragraphs: [
      "Establishing a New Medical College & Teaching Hospital is a multi-dimensional institutional project requiring coordinated planning across academic infrastructure, Teaching Hospital capabilities, faculty and resident manpower, clinical material, and statutory documentation.",
      "Nutrivio operates as an integrated professional partner. Our structured approach begins with evaluating institutional objectives and existing capabilities, followed by milestone planning, documentation coordination, gap identification, and institutional readiness support."
    ],
    pillars: [
      {
        number: "01",
        title: "Academic Infrastructure",
        description: "Planning support for lecture theaters, dissection halls, museums, central library, skills lab, and departmental demo rooms.",
        tag: "Campus",
        iconType: "blueprint"
      },
      {
        number: "02",
        title: "Teaching Hospital Ecosystem",
        description: "Bed strength planning, functional specialty wards, emergency/trauma care, modular OTs, ICUs, and clinical laboratory services.",
        tag: "Clinical",
        iconType: "hospital"
      },
      {
        number: "03",
        title: "Academic Medical Manpower",
        description: "Department-wise and designation-wise sourcing of genuine Permanent & Full-Time medical educators and resident doctors.",
        tag: "Staffing",
        iconType: "staffing"
      },
      {
        number: "04",
        title: "Institutional Readiness",
        description: "Comprehensive pre-assessment gap analysis, file auditing, hospital statistics review, and readiness planning.",
        tag: "Readiness",
        iconType: "readiness"
      }
    ]
  },
  whatWeDeliver: {
    badge: "Scope of Support",
    heading: "Key Services & Deliverables We Provide",
    subtitle: "Structured advisory milestones covering every critical component of New Medical College establishment.",
    deliverables: [
      {
        id: "01",
        title: "Preliminary Feasibility & Project Roadmap",
        description: "Initial assessment of the proposed Medical College project and development of a structured roadmap for institutional planning.",
        iconType: "audit"
      },
      {
        id: "02",
        title: "Proposed MBBS Intake & Institutional Planning",
        description: "Institutional capacity planning tailored to the proposed MBBS student intake and corresponding campus requirements.",
        iconType: "blueprint"
      },
      {
        id: "03",
        title: "Teaching Hospital & Bed Strength Assessment",
        description: "Structured review of Teaching Hospital bed distribution, clinical material adequacy, and specialty ward requirements.",
        iconType: "hospital"
      },
      {
        id: "04",
        title: "Department-wise Infrastructure Planning",
        description: "Planning support for departmental layouts, equipment, and lab setups across Pre-Clinical, Para-Clinical, and Clinical disciplines.",
        iconType: "readiness"
      },
      {
        id: "05",
        title: "Permanent & Full-Time Faculty Recruitment",
        description: "Department-wise and designation-wise faculty recruitment support according to institutional requirements.",
        iconType: "staffing"
      },
      {
        id: "06",
        title: "University & Statutory Documentation Support",
        description: "Professional assistance in organizing, coordinating, and preparing application documentation and online submissions.",
        iconType: "university"
      }
    ]
  },
  ourInsight: {
    badge: "OUR INSIGHT",
    heading: "Medical College Sanctions Depend On Active Clinical Foundations",
    description: "A Medical College cannot be established on brick-and-mortar infrastructure alone; its viability depends entirely on functional hospital footfall. Institutional approval requires an active bed census, documented OPD/IPD registries, operational critical care units, and genuine full-time academic faculty. Organizations investing in early hospital operationalization and structured documentation roadmaps build sustainable medical institutions with zero regulatory roadblocks.",
    imageUrl: img1,
    floatingTag: "Institutional Advisory Note",
    ctaText: "Explore Our Advisory Approach",
    ctaLink: "#enquiry-form-section"
  },
  businessImpact: {
    badge: "Institutional Impact",
    heading: "Strategic Value & Operational Outcomes for Your Institution",
    subtitle: "Structured planning prevents multi-crore session delays and ensures seamless launch.",
    impacts: [
      {
        id: "01",
        title: "Zero Timeline Delay",
        description: "Eliminate statutory filing rejections and launch your proposed college strictly within the target academic calendar.",
        iconType: "time"
      },
      {
        id: "02",
        title: "CAPEX Optimization",
        description: "Prevent infrastructure overspending by building exactly to mandated departmental and clinical norms.",
        iconType: "finance"
      },
      {
        id: "03",
        title: "Full Intake Capacity Realization",
        description: "Ensure complete clinical and academic readiness to support the planned 100, 150, or 250 annual MBBS student intake.",
        iconType: "growth"
      },
      {
        id: "04",
        title: "Long-Term Institutional Reputation",
        description: "Establish a benchmark medical institution with verified faculty, patient trust, and solid groundwork for future PG courses.",
        iconType: "reputation"
      }
    ]
  }
};

// -------------------------------------------------------------
// 02. MBBS SEAT EXPANSION
// -------------------------------------------------------------
export const mbbsExpansionData = {
  id: "mbbs-seat-expansion",
  slug: "/services/mbbs-seat-expansion",
  hero: {
    serviceName: "MBBS Seat Expansion",
    heading: "Expanding Institutional Capacity: Strategic Advisory for MBBS Seat Expansion",
    description:
      "For eligible existing Medical Colleges planning to increase their MBBS admission capacity, Nutrivio provides structured professional advisory, institutional gap assessment, and readiness support across academic and clinical domains.",
    points: [
      "Eligibility & Statutory Gap Assessment",
      "Proportional Faculty & Resident Manpower Planning",
      "Teaching Hospital Bed & OPD/IPD Activity Review",
      "Application Preparation & Online Submission Support"
    ],
    buttonText: "Discuss MBBS Expansion",
    buttonLink: "#enquiry-form-section",
    illustrationUrl: img02 // Path to 02.png
  },
  about: {
    tagline: "Academic Expansion Advisory",
    heading: "Scaling Medical College Intake with Academic & Clinical Rigor",
    paragraphs: [
      "Increasing MBBS student intake requires an existing medical college to demonstrate proportional growth across Teaching Hospital bed strength, patient inflow, specialized faculty, departmental laboratories, and library capacity.",
      "Nutrivio assists management teams in reviewing eligibility requirements, auditing existing clinical metrics, and closing manpower gaps well in advance of expansion applications."
    ],
    pillars: [
      {
        number: "01",
        title: "Capacity Auditing",
        description: "Auditing current institutional standing, batch performance, and eligibility criteria for intake expansion.",
        tag: "Eligibility",
        iconType: "audit"
      },
      {
        number: "02",
        title: "Clinical Footfall Validation",
        description: "Reviewing daily average OPD footfall, IPD admissions, bed occupancy records, and surgical load data.",
        tag: "Hospital",
        iconType: "hospital"
      },
      {
        number: "03",
        title: "Proportional Manpower",
        description: "Calculating and closing faculty vacancies with genuine, Permanent & Full-Time teaching appointments.",
        tag: "Faculty",
        iconType: "staffing"
      },
      {
        number: "04",
        title: "Infrastructure Upgradation",
        description: "Advising on expansion of lecture halls, lab stations, central library seats, and residential facilities.",
        tag: "Campus",
        iconType: "blueprint"
      }
    ]
  },
  whatWeDeliver: {
    badge: "Expansion Scope",
    heading: "Comprehensive MBBS Expansion Deliverables",
    subtitle: "Structured advisory deliverables to support your institution through every phase of intake expansion.",
    deliverables: [
      {
        id: "01",
        title: "Eligibility & Gap Assessment",
        description: "Detailed evaluation of institutional standing and statutory eligibility criteria for increased MBBS admissions.",
        iconType: "audit"
      },
      {
        id: "02",
        title: "Faculty & Resident Requirement Planning",
        description: "Department-wise calculation of additional Professors, Associate Professors, Assistant Professors, and Senior Residents.",
        iconType: "staffing"
      },
      {
        id: "03",
        title: "Teaching Hospital Bed Strength Review",
        description: "Assessment of required additional bed strength, ward configurations, and bed occupancy documentation.",
        iconType: "hospital"
      },
      {
        id: "04",
        title: "Infrastructure & Clinical Material Review",
        description: "Reviewing expansion of academic spaces, demonstration rooms, dissection tables, and student laboratory stations.",
        iconType: "blueprint"
      },
      {
        id: "05",
        title: "University Affiliation Documentation",
        description: "Professional assistance in organizing university consent of affiliation and statutory compliance paperwork.",
        iconType: "university"
      },
      {
        id: "06",
        title: "Institutional Readiness & Mock Review",
        description: "Mock verification walkthroughs to identify and address departmental, clinical, and documentation gaps.",
        iconType: "readiness"
      }
    ]
  },
  ourInsight: {
    badge: "OUR INSIGHT",
    heading: "Intake Expansion Demands Proportional Clinical Material Scalability",
    description: "Scaling annual MBBS admissions from 100 to 150 or 250 seats is fundamentally driven by hospital clinical capacity rather than classroom space. Sanctioning higher student intake requires verified expansion across specialty bed occupancy, surgical case turnover, pre-clinical laboratory stations, and faculty ratios. Institutions that audit and bridge departmental clinical gaps well before filing ensure seamless seat sanctions without statutory denials.",
    imageUrl: img2,
    floatingTag: "Expansion Strategy Note",
    ctaText: "Explore Our Expansion Framework",
    ctaLink: "#enquiry-form-section"
  },
  businessImpact: {
    badge: "Expansion ROI",
    heading: "Maximizing Institutional Scale & Revenue Potential",
    subtitle: "Unlocking higher annual student intake with optimized hospital operations.",
    impacts: [
      {
        id: "01",
        title: "Recurring Revenue Growth",
        description: "Significantly increase annual tuition fee collections through permanent, authorized expansion of annual MBBS seats.",
        iconType: "revenue"
      },
      {
        id: "02",
        title: "Optimized Hospital Turnover",
        description: "Convert enhanced bed strength and clinical departments into higher daily OPD/IPD patient volumes and diagnostic revenue.",
        iconType: "growth"
      },
      {
        id: "03",
        title: "Risk-Mitigated Expansion",
        description: "Prevent application rejection by ensuring academic manpower, clinical material, and floor spaces strictly match expansion norms.",
        iconType: "audit"
      },
      {
        id: "04",
        title: "Budgeted Faculty Scaling",
        description: "Avoid emergency hiring overheads by onboarding verified teaching doctors on structured, sustainable institutional packages.",
        iconType: "manpower"
      }
    ]
  }
};

// -------------------------------------------------------------
// 03. PG (MD/MS) COURSE & SEAT EXPANSION
// -------------------------------------------------------------
export const pgExpansionData = {
  id: "pg-course-seat-expansion",
  slug: "/services/pg-course-seat-expansion",
  hero: {
    serviceName: "PG (MD/MS) Course & Seat Expansion",
    heading: "Advancing Postgraduate Medical Education: New PG Courses & Seat Expansion",
    description:
      "Nutrivio provides professional advisory and documentation support for Medical Colleges planning to introduce New PG (MD/MS) Courses or increase seats in existing postgraduate programmes with rigorous department-level focus.",
    points: [
      "Department-wise Eligibility & Readiness Assessment",
      "Recognized PG Teacher & Senior Resident Planning",
      "Specialty Bed, OT & Clinical Material Review",
      "Application Preparation & Online Submission Assistance"
    ],
    buttonText: "Discuss PG Courses",
    buttonLink: "#enquiry-form-section",
    illustrationUrl: img03 // Path to 03.png
  },
  about: {
    tagline: "Postgraduate Medical Advisory",
    heading: "Elevating Institutions to Postgraduate Teaching Centers",
    paragraphs: [
      "Introducing new PG (MD/MS) disciplines or expanding postgraduate seats requires stringent department-level preparedness, recognized PG teachers, specialized clinical units, high surgical volumes, and dedicated departmental seminar rooms.",
      "Nutrivio works with department heads and hospital administrators to evaluate clinical metrics, verify faculty qualification documentation, and ensure complete department-wise readiness."
    ],
    pillars: [
      {
        number: "01",
        title: "PG Teaching Units",
        description: "Structuring compliant unit ratios with qualified Professors, Associate Professors, and Senior Residents.",
        tag: "Teaching",
        iconType: "staffing"
      },
      {
        number: "02",
        title: "Case-Mix & Surgical Load",
        description: "Ensuring adequate clinical variety, investigation volumes, and surgical loads essential for PG training.",
        tag: "Clinical",
        iconType: "hospital"
      },
      {
        number: "03",
        title: "Department Infrastructure",
        description: "Departmental seminar rooms, audio-visual facilities, departmental libraries, and research labs.",
        tag: "Academic",
        iconType: "blueprint"
      },
      {
        number: "04",
        title: "Credential Verification",
        description: "Pre-submission vetting of faculty degrees, teaching experience certificates, and publication requirements.",
        tag: "Verification",
        iconType: "audit"
      }
    ]
  },
  whatWeDeliver: {
    badge: "PG Advisory Deliverables",
    heading: "Scope of Postgraduate Advisory & Support",
    subtitle: "End-to-end guidance to introduce new postgraduate disciplines and expand existing MD/MS capacity.",
    deliverables: [
      {
        id: "01",
        title: "Department Eligibility Assessment",
        description: "Evaluating MBBS batch standing and department eligibility for introducing new PG specialities.",
        iconType: "audit"
      },
      {
        id: "02",
        title: "PG Faculty & Resident Planning",
        description: "Structuring department teaching units, assessing eligible PG guides, and identifying faculty requirements.",
        iconType: "staffing"
      },
      {
        id: "03",
        title: "Qualification & Publication Review",
        description: "Structured vetting of faculty qualification dossiers, teaching experience, and indexed research publications.",
        iconType: "readiness"
      },
      {
        id: "04",
        title: "Clinical Material & Equipment Audit",
        description: "Assessing departmental bed strength, specialized OPD days, major/minor surgeries, and diagnostic equipment.",
        iconType: "hospital"
      },
      {
        id: "05",
        title: "University & Statutory Paperwork",
        description: "Assistance in securing university consent of affiliation and organizing statutory PG documentation dossiers.",
        iconType: "university"
      },
      {
        id: "06",
        title: "Departmental Readiness Support",
        description: "Departmental mock assessment, logbook preparation, seminar room setup, and clinical registry verification.",
        iconType: "readiness"
      }
    ]
  },
  ourInsight: {
    badge: "OUR INSIGHT",
    heading: "Postgraduate Sanctions Depend On Case Complexity & Verified Teaching Units",
    description: "Introducing recognized MD/MS programs requires clinical depth and specialized operative variety beyond general patient volume. Postgraduate approval demands recognized PG guides with authenticated teaching tenure, specialized modular surgical suites, advanced diagnostics, and dedicated seminar archives. Medical colleges that structure compliant departmental units and audit clinical case-mix successfully transition into premier postgraduate research destinations.",
    imageUrl: img3,
    floatingTag: "Postgraduate Advisory Note",
    ctaText: "Explore Our Postgraduate Roadmap",
    ctaLink: "#enquiry-form-section"
  },
  businessImpact: {
    badge: "Specialty Impact",
    heading: "Transforming Medical Colleges into Advanced Teaching Hubs",
    subtitle: "Elevating hospital surgical volumes, resident coverage, and academic prestige.",
    impacts: [
      {
        id: "01",
        title: "24/7 Clinical Resident Coverage",
        description: "Secure dedicated postgraduate resident doctors providing round-the-clock inpatient, emergency, and ICU hospital care.",
        iconType: "manpower"
      },
      {
        id: "02",
        title: "Advanced Surgical & Case-Mix Revenue",
        description: "Attract higher-tier specialty cases and surgical procedures, significantly increasing hospital operating revenues.",
        iconType: "revenue"
      },
      {
        id: "03",
        title: "Premium Academic Brand Distinction",
        description: "Establish your institution as a respected postgraduate destination, attracting high-caliber faculty and medical researchers.",
        iconType: "reputation"
      },
      {
        id: "04",
        title: "Sustainable Fee Architecture",
        description: "Monetize specialized clinical departments through high-demand MD/MS specialty and super-specialty seat allocations.",
        iconType: "growth"
      }
    ]
  }
};

// -------------------------------------------------------------
// 04. INSTITUTIONAL & TEACHING HOSPITAL COMPLIANCE
// -------------------------------------------------------------
export const complianceData = {
  id: "institutional-compliance",
  slug: "/services/institutional-compliance",
  hero: {
    serviceName: "Institutional & Teaching Hospital Compliance",
    heading: "Strengthening Institutional Preparedness: Integrated Academic & Clinical Support",
    description:
      "A Medical College and its Teaching Hospital operate as an integrated ecosystem. Nutrivio assists institutions in reviewing and strengthening key components related to academic manpower, hospital operations, clinical material, and infrastructure.",
    points: [
      "Faculty & Resident Strength Verification",
      "Teaching Hospital Bed & Clinical Activity Review",
      "Critical Clinical Services (ICU, OT, Emergency) Audit",
      "Holistic Institutional Gap Identification"
    ],
    buttonText: "Discuss Institutional Readiness",
    buttonLink: "#enquiry-form-section",
    illustrationUrl: img04 // Path to 04.png
  },
  about: {
    tagline: "Institutional Preparedness",
    heading: "Harmonizing Teaching Hospital Operations with Academic Standards",
    paragraphs: [
      "A Teaching Hospital serves as the live clinical training ground for medical students. It must maintain active patient occupancy, functional critical care units, modern diagnostic equipment, and documented daily statistics.",
      "Nutrivio conducts structured institutional reviews across all academic departments, clinical wards, and operational services to identify gaps and support corrective preparedness planning."
    ],
    pillars: [
      {
        number: "01",
        title: "Hospital Activity Census",
        description: "Auditing daily OPD registers, IPD admissions, discharge summaries, and bed occupancy documentation.",
        tag: "Operations",
        iconType: "hospital"
      },
      {
        number: "02",
        title: "Critical Care Services",
        description: "Preparedness audit of ICU, ICCU, NICU, PICU, Emergency/Trauma Care, and modular Operation Theatres.",
        tag: "Critical Care",
        iconType: "readiness"
      },
      {
        number: "03",
        title: "Diagnostic & Support Labs",
        description: "Review of Central Clinical Laboratories (Biochemistry, Pathology, Microbiology), Blood Bank, and Radio-diagnosis.",
        tag: "Diagnostics",
        iconType: "blueprint"
      },
      {
        number: "04",
        title: "Academic Facilities",
        description: "Inspection of Central Library, Simulation Skill Labs, Anatomy Dissection Hall, and Departmental Museums.",
        tag: "Academic",
        iconType: "audit"
      }
    ]
  },
  whatWeDeliver: {
    badge: "Compliance Areas",
    heading: "Key Areas of Institutional Readiness Support",
    subtitle: "Structured evaluation across all major academic, hospital, and diagnostic facilities.",
    deliverables: [
      {
        id: "01",
        title: "Academic Manpower Review",
        description: "Assessing faculty and resident physician strength across all Pre-Clinical, Para-Clinical, and Clinical departments.",
        iconType: "staffing"
      },
      {
        id: "02",
        title: "Teaching Hospital Bed Strength",
        description: "Auditing specialty-wise bed allocations, clinical ward equipment, nursing stations, and duty doctor rooms.",
        iconType: "hospital"
      },
      {
        id: "03",
        title: "Hospital Activity & Occupancy Logs",
        description: "Systematic auditing of daily OPD registers, IPD admissions, surgical records, and bed occupancy data.",
        iconType: "audit"
      },
      {
        id: "04",
        title: "Critical Care & OT Preparedness",
        description: "Reviewing functionality of modular Operation Theatres, central oxygen supply, ICU beds, and emergency care.",
        iconType: "readiness"
      },
      {
        id: "05",
        title: "Diagnostic & Blood Bank Setup",
        description: "Reviewing Central Clinical Laboratories, Blood Bank equipment, and Radio-diagnosis facilities.",
        iconType: "blueprint"
      },
      {
        id: "06",
        title: "Corrective Compliance Planning",
        description: "Generating structured gap reports and milestone-based action plans to strengthen overall institutional preparedness.",
        iconType: "university"
      }
    ]
  },
  ourInsight: {
    badge: "OUR INSIGHT",
    heading: "Regulatory Compliance Requires Absolute Concordance Between Ground & Digital Records",
    description: "Teaching hospitals face their highest compliance risks when physical ward occupancy diverges from software and pharmacy registries during assessments. Total institutional preparedness demands synchronization between live patient census, emergency triage readiness, diagnostic logs, and statutory faculty mandates. Institutions maintaining continuous internal audit rigor protect themselves against unexpected show-cause notices and de-recognition threats.",
    imageUrl:img4,
    floatingTag: "Hospital Preparedness Note",
    ctaText: "Explore Our Compliance Methodology",
    ctaLink: "#enquiry-form-section"
  },
  businessImpact: {
    badge: "Compliance Assurance",
    heading: "Protecting Institutional Accreditation & Operational Continuity",
    subtitle: "Eliminating regulatory vulnerabilities, de-recognition threats, and financial penalties.",
    impacts: [
      {
        id: "01",
        title: "De-Recognition Threat Shield",
        description: "Protect your institution against surprise inspection discrepancies, show-cause notices, and seat reductions.",
        iconType: "audit"
      },
      {
        id: "02",
        title: "Enhanced Daily Hospital Census",
        description: "Restructure OPD/IPD workflows and patient registration registers to genuinely reflect active hospital occupancy.",
        iconType: "growth"
      },
      {
        id: "03",
        title: "Diagnostic Facility Monetization",
        description: "Ensure complete operational readiness of Blood Bank, central pathology labs, CT/MRI, and ultrasound equipment.",
        iconType: "revenue"
      },
      {
        id: "04",
        title: "Audit-Ready Clinical Records",
        description: "Eliminate discrepancies between physical ward occupancy and daily nursing registers across all specialty wards.",
        iconType: "time"
      }
    ]
  }
};

// -------------------------------------------------------------
// 05. DOCUMENTATION & INSTITUTIONAL READINESS
// -------------------------------------------------------------
export const documentationData = {
  id: "documentation-readiness",
  slug: "/services/documentation-readiness",
  hero: {
    serviceName: "Documentation & Institutional Readiness",
    heading: "Structured Documentation. Stronger Institutional Preparedness.",
    description:
      "Effective institutional readiness requires systematic organisation of academic records, faculty qualification dossiers, hospital statistics, and statutory documentation. Nutrivio provides structured documentation and preparedness support.",
    points: [
      "Department-wise Document Review & Verification",
      "Faculty Credential & Experience Dossier Auditing",
      "Hospital Statistics & HIS Record Reconciliation",
      "Online Application Preparation & Submission Support"
    ],
    buttonText: "Request Documentation Support",
    buttonLink: "#enquiry-form-section",
    illustrationUrl: img05 // Path to 05.png
  },
  about: {
    tagline: "Governance & Documentation",
    heading: "Precision Documentation to Back Every Institutional Asset",
    paragraphs: [
      "Institutional readiness extends beyond physical infrastructure. Academic registers, faculty service dossiers, hospital statistics, and statutory applications require meticulous compilation and concordance.",
      "Nutrivio's documentation specialists review, index, and organize departmental files and statutory paperwork to establish complete, verified institutional records."
    ],
    pillars: [
      {
        number: "01",
        title: "Faculty Dossiers",
        description: "Authenticity review of council registrations, qualification degrees, experience certificates, and declarations.",
        tag: "Credentials",
        iconType: "staffing"
      },
      {
        number: "02",
        title: "Hospital Statistics Concordance",
        description: "Reconciling manual registers, Hospital Information System (HIS) data, pharmacy dispensations, and lab logs.",
        tag: "Reconciliation",
        iconType: "audit"
      },
      {
        number: "03",
        title: "Statutory Approvals Dossier",
        description: "Organizing environmental clearances, AERB approvals for radiology, Fire safety NOC, and building clearances.",
        tag: "Statutory",
        iconType: "university"
      },
      {
        number: "04",
        title: "Departmental SOPs",
        description: "Standardizing department operational procedures, student logbooks, and biomedical waste management records.",
        tag: "Standardization",
        iconType: "readiness"
      }
    ]
  },
  whatWeDeliver: {
    badge: "Documentation Scope",
    heading: "Comprehensive Documentation & Readiness Deliverables",
    subtitle: "Structured documentation review and readiness services to ensure complete file preparedness.",
    deliverables: [
      {
        id: "01",
        title: "Application & Institutional Records",
        description: "Reviewing land documentation, trust deeds, essentiality certificates, and institutional registration records.",
        iconType: "university"
      },
      {
        id: "02",
        title: "Department-wise Document Review",
        description: "Standardizing department registers, student logbooks, equipment maintenance logs, and stock registers.",
        iconType: "blueprint"
      },
      {
        id: "03",
        title: "Faculty Documentation Readiness",
        description: "Verifying MBBS/MD/MS degrees, state medical council registrations, past teaching experience, and joining records.",
        iconType: "staffing"
      },
      {
        id: "04",
        title: "Hospital Statistics Documentation",
        description: "Validating OPD/IPD registers, surgical records, investigation logs, and daily census concordance.",
        iconType: "hospital"
      },
      {
        id: "05",
        title: "Online Application & Submission Support",
        description: "Assistance with statutory portal document formatting, metadata indexing, and secure submission workflows.",
        iconType: "audit"
      },
      {
        id: "06",
        title: "Gap Identification & Corrective Planning",
        description: "Structured gap identification report and step-by-step corrective planning to achieve complete audit readiness.",
        iconType: "readiness"
      }
    ]
  },
  ourInsight: {
    badge: "OUR INSIGHT",
    heading: "Institutional Approvals Depend On Audit-Proof Governance Dossiers",
    description: "Even premier clinical infrastructure risks application rejection if statutory affidavits, land documentation, and faculty portfolios contain discrepancies. Achieving first-time portal acceptance requires systematic record reconciliation, degree authentications, building completion clearances, and standardized departmental logbooks. Organizations that prioritize precision documentation eliminate procedural delays and establish permanent institutional archives.",
    imageUrl:img5,
    floatingTag: "Governance Advisory Note",
    ctaText: "Explore Our Governance Approach",
    ctaLink: "#enquiry-form-section"
  },
  businessImpact: {
    badge: "Governance Value",
    heading: "Audit-Proof Governance & Frictionless Approvals",
    subtitle: "Eliminating data mismatches between physical assets, HIS records, and statutory dossiers.",
    impacts: [
      {
        id: "01",
        title: "First-Time-Right Portal Submissions",
        description: "Prevent application rejection due to incorrect indexing, mismatched declarations, or format deficiencies.",
        iconType: "time"
      },
      {
        id: "02",
        title: "Legal & Council Protection",
        description: "Vetted faculty experience certificates and council clearances protect the institution from administrative penalties.",
        iconType: "audit"
      },
      {
        id: "03",
        title: "HIS & Register Concordance",
        description: "Ensure complete mathematical and operational alignment between HIS software, billing, and physical patient registers.",
        iconType: "growth"
      },
      {
        id: "04",
        title: "Permanent Institutional Archiving",
        description: "Establish a structured digital and physical documentation library for recurring annual inspection cycles.",
        iconType: "reputation"
      }
    ]
  }
};

// -------------------------------------------------------------
// 06. MEDICAL FACULTY RECRUITMENT
// -------------------------------------------------------------
export const facultyRecruitmentData = {
  id: "medical-faculty-recruitment",
  slug: "/services/medical-faculty-recruitment",
  hero: {
    serviceName: "Medical Faculty Recruitment",
    heading: "Permanent & Full-Time Medical Faculty Recruitment",
    description:
      "Nutrivio Medical Services provides professional recruitment support to Medical Colleges and Teaching Hospitals seeking suitable qualified medical professionals for genuine Permanent & Full-Time academic appointments.",
    points: [
      "Pre-Clinical, Para-Clinical & Clinical Specialities",
      "Professor, Associate Professor, Assistant Professor, SR & Tutor",
      "100% Verified Qualifications & Teaching Experience",
      "End-to-End Screening, Coordination & Onboarding Support"
    ],
    buttonText: "Request Medical Faculty",
    buttonLink: "#enquiry-form-section",
    illustrationUrl: img06 // Path to 06.png
  },
  about: {
    tagline: "Academic Manpower Solutions",
    heading: "Building the Academic Strength of Medical Institutions",
    paragraphs: [
      "The academic reputation and regulatory standing of a Medical College depend fundamentally upon the competence, qualifications, and full-time presence of its teaching faculty.",
      "Nutrivio recruits only genuine Permanent & Full-Time academic doctors across all Pre-Clinical, Para-Clinical, and Clinical departments, managing the entire talent acquisition process from requirement assessment through to onboarding."
    ],
    pillars: [
      {
        number: "01",
        title: "Pre-Clinical Departments",
        description: "Faculty recruitment across Anatomy, Physiology, and Biochemistry across all senior and junior designations.",
        tag: "Pre-Clinical",
        iconType: "blueprint"
      },
      {
        number: "02",
        title: "Para-Clinical Departments",
        description: "Pathology, Microbiology, Pharmacology, Forensic Medicine & Toxicology, and Community Medicine.",
        tag: "Para-Clinical",
        iconType: "audit"
      },
      {
        number: "03",
        title: "Clinical & Allied Departments",
        description: "General Medicine, General Surgery, OBG, Pediatrics, Orthopedics, ENT, Ophthalmology, Anesthesia, Radio-diagnosis.",
        tag: "Clinical",
        iconType: "hospital"
      },
      {
        number: "04",
        title: "Academic Designations",
        description: "Recruitment covering Professors, Associate Professors, Assistant Professors, Senior Residents, and Tutors.",
        tag: "Hierarchy",
        iconType: "staffing"
      }
    ]
  },
  whatWeDeliver: {
    badge: "Recruitment Workflow",
    heading: "Our 6-Stage Faculty Recruitment Process",
    subtitle: "From department requirement assessment to verified documentation and onboarding assistance.",
    deliverables: [
      {
        id: "01",
        title: "Requirement Assessment",
        description: "Understanding exact Department-wise and Designation-wise faculty requirements according to student intake.",
        iconType: "audit"
      },
      {
        id: "02",
        title: "Faculty Sourcing & Network Activation",
        description: "Identifying suitable qualified medical professionals through our verified nationwide professional network.",
        iconType: "staffing"
      },
      {
        id: "03",
        title: "Preliminary Screening & Alignment",
        description: "Initial screening based on institutional requirements, qualifications, relocation preferences, and availability.",
        iconType: "readiness"
      },
      {
        id: "04",
        title: "Documentation & Credential Review",
        description: "Collecting and reviewing qualification degrees, state medical council registrations, and teaching experience records.",
        iconType: "university"
      },
      {
        id: "05",
        title: "Profile & Interview Coordination",
        description: "Coordinating suitable candidate dossiers with college management and facilitating professional interview rounds.",
        iconType: "blueprint"
      },
      {
        id: "06",
        title: "Selection & Onboarding Support",
        description: "Assisting through candidate selection, joining date alignment, and onboarding documentation formalities.",
        iconType: "hospital"
      }
    ]
  },
  ourInsight: {
    badge: "OUR INSIGHT",
    heading: "Academic Manpower Stability Demands Genuine Full-Time Appointments",
    description: "With biometric verification and digital tracking universal across medical education, temporary or unverified faculty appointments create fatal operational risks. Sustainable institutional credibility requires sourcing verified medical educators across all specialties with authenticated qualifications, clear relieving certificates, and long-term commitment. Institutions that invest in genuine academic leadership ensure continuous curriculum excellence and zero compliance deficiencies.",
    imageUrl: img6,
    floatingTag: "Academic Manpower Note",
    ctaText: "Explore Our Faculty Solutions",
    ctaLink: "#enquiry-form-section"
  },
  businessImpact: {
    badge: "Manpower Stability",
    heading: "Sustainable Academic Strength & Zero Inspection Vulnerability",
    subtitle: "Eliminating faculty deficiencies with verified full-time medical educators.",
    impacts: [
      {
        id: "01",
        title: "100% Genuine Full-Time Appointments",
        description: "Eliminate regulatory penalties and assessment cancellations by hiring verified full-time doctors rather than temporary arrangements.",
        iconType: "audit"
      },
      {
        id: "02",
        title: "Fast-Track Sourcing Pipeline",
        description: "Tap into our active network of qualified medical specialists to close critical departmental vacancies in weeks, not months.",
        iconType: "time"
      },
      {
        id: "03",
        title: "Higher Faculty Retention",
        description: "Pre-screen candidates for long-term location preference and institutional alignment, minimizing mid-academic attrition.",
        iconType: "reputation"
      },
      {
        id: "04",
        title: "Full Credential Authentication",
        description: "Receive complete, pre-vetted dossiers containing degree authentications, state council registrations, and verified relieving letters.",
        iconType: "growth"
      }
    ]
  }
};

// Map object for lookup
export const SERVICES_DATA = {
  "new-medical-college-establishment": newMedicalCollegeData,
  "mbbs-seat-expansion": mbbsExpansionData,
  "pg-course-seat-expansion": pgExpansionData,
  "institutional-compliance": complianceData,
  "documentation-readiness": documentationData,
  "medical-faculty-recruitment": facultyRecruitmentData
};